export const clientData = [
    {
        heading: 'Getting Started',
        preliminaryInfo: `Welcome to the official user guide for The Proven Group's app, designed to streamline and expedite service and quote requests for our valued clients. This application has been crafted with the utmost care to provide you with a seamless and efficient experience. Whether you need a service or a quote, this app is your go-to tool for swift and hassle-free submissions. Explore the features from the side menu to make the most of your client experience with The Proven Group.`,
        subheadings: ['Installation', 'Main Screen', 'Profile'],
    },
    {
        heading: 'Request for Service',
        preliminaryInfo: 'The service request screen offers a user-friendly interface for promptly submitting service requests for your equipment. Primarily, these requests are commonly related to issues with either cooling (no A/C) or heating (no heat). However, there is also a details section available, allowing you to provide additional specific information about the service request. Explore this section for straightforward access to efficiently communicate your equipment service needs. Please navigate to the side menu and select the relevant option to access detailed instructions.',
        subheadings: ['Start a Service Request', 'General', 'Location', 'Type of Service', 'Details', 'Submit Request'],
    },
    {
        heading: 'Request for Quote',
        preliminaryInfo: 'The quote request screen offers a user-friendly interface for promptly submitting quote requests for your equipment needs. There is a details section available, allowing you to provide specific information about the request. Explore this section for straightforward access to efficiently communicate your quote. Please navigate to the side menu and select the relevant option to access detailed instructions.',
        subheadings: ['Start a Quote Request', 'General', 'Location', 'Details', 'Submit Request'],
    },
    {
        heading: 'FAQ',
        preliminaryInfo: 'Find answers to commonly asked questions:',
        subheadings: ['General', 'Troubleshooting'],
    },
    {
        heading: 'Privacy & Terms',
        preliminaryInfo: "At The Proven Group, we are dedicated to providing you with exceptional service while prioritizing your privacy and security. This Policy & Terms section outlines important information regarding the use of The Proven Group App, including our Privacy Policy, Deletion Policy, and Terms of Use. By accessing or using our app, you agree to comply with these policies and terms. Please take a moment to review the following information carefully. If you have any questions or concerns, don't hesitate to reach out to us at info@provengroup.ca. Thank you for choosing The Proven Group.",
        subheadings: ['Privacy Policy', 'Deletion Policy', 'Terms of Use'],
    },
];

export const ClientMainScreen = ()=>{
    return(
      <div>
        <div>The main screen offers two primary selections: Client and Technician. If you are a client, there is no need for a mandatory login. Simply choose the Client option, and you are ready to effortlessly submit your service and quote requests.</div>
        <ol>
          <li>From the main screen you will choose the CLIENT icon</li>
        </ol>
      </div>
    );
};
  
export const Profile = ()=>{
    return(
      <div>
        <div>To streamline your experience and minimize the need for repetitive typing, consider setting up your profile directly on your phone. Please note that the profile information is stored exclusively on the current device. This stored data is utilized to automatically populate request forms, reducing the amount of manual input required. Follow the steps below to establish your profile and enjoy a more efficient request submission process.</div>
        <ol>
          <li>From the Client Options Screen press the PROFILE icon</li>
          <li>Client Name - please fill out your company name</li>
          <li>Email Address - please fill out your email address where you would like to be contacted for correspondence of requests</li>
          <li>Phone Number - please fill out the phone number to use for correspondence of requests</li>
          <li>Locations - press the plus sign to add an address</li>
          <li>In the new Address field that appeared, enter in the address for where the service will take place</li>
          <li>If you have more than one location that requires service, press the plus sign and add the other addresses</li>
          <li>For each address entered there is a delete button below it. If the address is no longer needed press the delete button and confirm.</li>
          <li>Press the back button (arrow at the top) when finished</li>
        </ol>
      </div>
    );
};
  
export const StartServiceRequest = ()=>{
    return(
      <ol>
        <li>From the Client Options screen select the REQUEST FOR SERVICE icon</li>
      </ol>
    );
};
  
export const StartQuoteRequest = ()=>{
    return(
      <ol>
        <li>From the Client Options screen select the REQUEST FOR QUOTE icon</li>
      </ol>
    );
};
  
export const ClientRequestGeneral = ()=>{
    return(
      <div>
        <div>
          If you have completed your profile information, the fields for Client Name, Email Address, and Phone Number will be automatically filled in. If your profile information is not yet completed, please refer to the following steps to input the required details in those fields.
        </div>
        <ol>
          <li>Client Name - please fill out your company name</li>
          <li>Email Address - please fill out your email address where you would like to be contacted for correspondence of requests</li>
          <li>Phone Number - please fill out the phone number to use for correspondence of requests</li>
        </ol>
        <div>NOTE: You may always select a field and re-type the information.</div>
      </div>
    );
};
  
export const ClientRequestLocation = ()=>{
    return(
      <div>
        <div>If you have completed your profile information, please select the location from the dropdown menu to populate the address input field. If your profile information is not yet completed, please refer to the following step to input the required detail.</div>
        <ol>
          <li>In the Address field, enter in the address for where the service will take place</li>
        </ol>
        <div>NOTE: You may always select a field and re-type the information after selecting from the dropdown menu.</div>
      </div>
    )
};
  
export const TypeOfService = ()=>{
    return(
      <div>
        <div>In the service type section, you will find a dropdown menu offering options such as `no A/C, `no heat`, or `Other`, If you select `Other` kindly furnish additional information in the details section. See Details section for examples.</div>
      </div>
    );
};
  
export const ServiceDetails = ()=>{
    return(
      <div>
        <div>After selecting the Type of Service, it is advisable to enter details to facilitate the processing of your request. Please refer to the examples below for guidance.</div>
        <div style={{marginTop: '10px'}}>Some examples:</div>
        <ul>
          <li>Unit number</li>
          <li>Door codes</li>
          <li>Unit locations</li>
          <li>If Type of Service is Other: Spring Maintenance</li>
        </ul>
      </div>
    );
};
  
export const QuoteDetails = ()=>{
    return(
      <div>
        <div> Kindly furnish a summary of the quote in the details section to facilitate the initiation of the process by The Proven Group team. Please refer to the examples below for guidance.</div>
        <div style={{marginTop: '10px'}}>Some examples:</div>
        <ul>
            <li>New units</li>
            <li>Condenser Fan Motor / Rain Shield / Run Capacitor Replacement </li>
            <li>Crankcase Heater Replacement</li>
            <li>Main Control Board Replacement</li>
        </ul>
        <div>Note:  Ensure that your contact information in the request is accurate to allow a team member to reach out to you if necessary.</div>
      </div>
    );
};
  
export const ClientSubmit = ()=>{
    return(
      <div>
        <div>After completing the necessary fields, tap the SUBMIT icon to send the message. A confirmation within the app will indicate that the submission was successful. Additionally, an email containing the request information will be sent to the provided email address. If you do not receive the email, please double-check the accuracy of the email address, as any discrepancies may impact the request. Rest assured, The Proven Group has received your request and will begin processing it.</div>
      </div>
    );
};

export const PrivacyPolicy = ()=>{
    return(
        <div className={styles.page}>
            <div className={styles.container}>
                <p>At The Proven Group Company, we are committed to protecting the privacy and security of our users' personal information. This Privacy Policy outlines how we collect, use, disclose, and safeguard your data when you use our The Proven Group App. By accessing or using our app, you agree to the terms of this Privacy Policy.</p>
            
                <h5>Information We Collect:</h5>
                <ol>
                    <li><strong>Personal Information:</strong> When you register an account with The Proven Group, we may collect personal information such as your name, email address, phone number, and company details. This information is necessary for user authentication and account management purposes.</li>
                    <li><strong>Usage Data:</strong> We may collect data about how you interact with our app, including information about your device, IP address, app usage statistics, and performance metrics. This data helps us improve our app's functionality, performance, and user experience.</li>
                </ol>

                <h5>How We Use Your Information:</h5>
                <ol>
                    <li><strong>To Provide Services:</strong> We use your personal information to authenticate users, manage accounts, and provide the services offered through our App, including dispatching, scheduling, and job tracking functionalities.</li>
                    <li><strong>To Improve Our App:</strong> We analyze usage data and feedback to enhance our app's functionality, optimize performance, and develop new features that better meet the needs of our users.</li>
                    <li><strong>To Communicate with You:</strong> We may use your contact information to send important updates, notifications, service-related announcements, and promotional materials about The Proven Group Company's products and services. You can opt out of promotional communications at any time.</li>
                </ol>

                <h5>Data Sharing and Disclosure:</h5>
                <ol>
                    <li><strong>Service Providers:</strong> We may share your information with third-party service providers who assist us in delivering and improving our app's functionality, such as cloud hosting, data analytics, and customer support services. These service providers are contractually obligated to protect your information and use it only for the purposes specified by The Proven Group Company.</li>
                    <li><strong>Legal Compliance:</strong> We may disclose your information to comply with applicable laws, regulations, legal processes, or government requests, or to protect the rights, property, or safety of The Proven Group Company, our users, or others.</li>
                </ol>

                <h5>Data Security:</h5>
                <p>We implement industry-standard security measures to protect your personal information from unauthorized access, disclosure, alteration, or destruction. However, no method of transmission over the internet or electronic storage is 100% secure, and we cannot guarantee absolute security.</p>
                
                <h5>Data Retention:</h5>
                <p>We retain your personal information for as long as necessary to fulfill the purposes outlined in this Privacy Policy unless a longer retention period is required or permitted by law. We will securely delete or anonymize your data when it is no longer needed for its intended purpose.</p>
                
                <h5>Changes to This Privacy Policy:</h5>
                <p>We may update this Privacy Policy from time to time to reflect changes in our practices or legal requirements. We will notify you of any material changes by posting the updated Privacy Policy on our website or through other means of communication. Your continued use of the The Proven Group App after the effective date of the revised Privacy Policy constitutes your acceptance of the changes.</p>
                
                <h5>Contact Us:</h5>
                <p>If you have any questions, concerns, or feedback regarding this Privacy Policy or our data practices, please contact us at info@provengroup.ca.</p>

                <p><strong>Last Updated:</strong> 03/24/2024</p>
                <p>This Privacy Policy applies solely to information collected through The Proven Group App operated by The Proven Group Company and does not apply to any third-party websites, services, or applications linked to or from our app. We encourage you to review the privacy policies of those third parties before providing any personal information.</p>
            </div>
        </div>
    );
};

export const DeletionPolicy = ()=>{
    return(
        <div className={styles.page}>
            <div className={styles.container}>
                <div className={styles.list}>
                    <h5>Steps to Request Deletion:</h5>
                    <ol>
                        <li><strong>Contact Us:</strong> Send an email to <a href="mailto:info@provengroup.ca">info@provengroup.ca</a> with the subject line "Account Deletion Request." Please ensure that you use the email address associated with your Proven Group account.</li>
                        <li><strong>Provide Information:</strong> In your email, include your full name and any additional information that can help us identify your account. This may include your registered email address, phone number, or company details.</li>
                        <li><strong>Confirmation:</strong> Upon receiving your request, we will verify your identity and process your account deletion within a reasonable timeframe. You may receive further communication from us to confirm your deletion request.</li>
                    </ol>
                </div>

                <h5>Types of Data Deleted:</h5>
                <ul>
                    <li><strong>Personal Information:</strong> Your name, email address, phone number, and any other information provided during account registration will be permanently deleted from our systems. Items required by law to retain will not be deleted, for example records of work performed and the associated data.</li>
                    <li><strong>Usage Data:</strong> Any data related to your app usage, such as device information, IP address, and app usage statistics, will be removed from our records.</li>
                </ul>

                <h5>Retention Period:</h5>
                <ul>
                    <li>We will promptly delete your account and associated data upon receiving your deletion request.</li>
                    <li>Please note that certain data may be retained for a limited period as required by law or for legitimate business purposes, such as fulfilling legal obligations or resolving disputes. However, such data will be securely stored and not used for any other purpose.</li>
                </ul>

                <p><strong>Last Updated:</strong> 03/24/2024</p>

                <p>For any questions or concerns regarding our deletion policy or the handling of your personal information, please contact us at <a href="mailto:info@provengroup.ca">info@provengroup.ca</a>.</p>
                
                <p>Thank you for trusting The Proven Group Company with your privacy. We are committed to ensuring the security and confidentiality of your data.</p>
            </div>
        </div>
    );
};

export const TermsOfUse = ()=>{
    return(
        <div className={styles.page}>
            <div class="container">
                <div class="list">
                    <h5>1. Acceptance of Terms</h5>
                    <p>Welcome to The Proven Group App provided by The Proven Group Company. By accessing or using our app, you agree to comply with these Terms of Use, our Privacy Policy, and any additional terms and conditions referenced herein. If you do not agree to these terms, please do not use our app.</p>
                </div>

                <div class="list">
                    <h5>2. Use of the App</h5>
                    <p>You must be at least 18 years old to use The Proven Group App. You are solely responsible for ensuring that your use of the app complies with all applicable laws, regulations, and third-party agreements. You agree not to use the app for any unlawful or prohibited purpose or to engage in any activity that could disrupt, damage, or interfere with the operation of the app.</p>
                </div>

                <div class="list">
                    <h5>3. Account Registration</h5>
                    <p>To access certain features of The Proven Group App, you may be required to register for an account. You agree to provide accurate, current, and complete information during the registration process and to update your information promptly if there are any changes. You are responsible for maintaining the confidentiality of your account credentials and for all activities that occur under your account.</p>
                </div>

                <div class="list">
                    <h5>4. Intellectual Property</h5>
                    <p>The Proven Group App and its content, including but not limited to text, graphics, logos, images, software, and trademarks, are the property of The Proven Group Company and are protected by copyright and other intellectual property laws. You may not modify, reproduce, distribute, display, or transmit any portion of the app without the prior written consent of The Proven Group Company.</p>
                </div>

                <div class="list">
                    <h5>5. Limitation of Liability</h5>
                    <p>To the fullest extent permitted by law, The Proven Group Company and its affiliates, officers, directors, employees, and agents shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising out of or in connection with your use of The Proven Group App, even if advised of the possibility of such damages.</p>
                </div>

                <div class="list">
                    <h5>6. Changes to Terms</h5>
                    <p>The Proven Group Company reserves the right to modify or update these Terms of Use at any time without prior notice. Any changes will be effective immediately upon posting to this page. It is your responsibility to review these terms periodically for updates. Your continued use of The Proven Group App following the posting of changes constitutes your acceptance of such changes.</p>
                </div>

                <div class="list">
                    <h5>7. Governing Law</h5>
                    <p>These Terms of Use shall be governed by and construed in accordance with the laws of Ontario Canada, without regard to its conflict of law provisions. Any dispute arising out of or in connection with these terms shall be resolved exclusively in the courts of Ontario Canada.</p>
                </div>

                <div class="list">
                    <h5>8. Contact Us</h5>
                    <p>If you have any questions or concerns about these Terms of Use or The Proven Group App, please contact us at info@provengroup.ca.</p>
                </div>

                <p><strong>Last Updated:</strong> 03/24/2024</p>
            </div>
        </div>
    );
};

const styles={
    page:{
        fontFamily: 'Arial, sans-serif',
        margin: '20px',
        lineHeight: '1.6',
    },
    h1: {
        textAlign: 'center',
    },
    h2: {
        texAlign: 'center',
    },
    container: {
        maxWidth: '800px',
        margin: '0 auto',
    },
    list: {
        marginBottom: '20px',
    },
};
